<div class="flex justify-end space-x-2 me-2 mb-2">
  <button
    (click)="expandAll()"
    type="button"
    class="font-medium disabled:text-gray-400 hover:text-gray-500 cursor-pointer hover:scale-110"
    appAgentAction
    agent="nw-number-accordion-expand-all"
    action="expand"
  >
    <app-chevron-double-down-icon></app-chevron-double-down-icon>
  </button>
  <button
    (click)="collapseAll()"
    type="button"
    class="font-medium disabled:text-gray-400 hover:text-gray-500 cursor-pointer hover:scale-110"
    appAgentAction
    agent="nw-number-accordion-collapse-all"
    action="toggle"
  >
    <app-chevron-double-up-icon></app-chevron-double-up-icon>
  </button>
</div>
<div class="rounded-md overflow-hidden shadow-md max-h-screen-175 min-h-screen-175 overflow-y-auto">
  @for (groupedNwNumber of groupedNwNumbers; track $index) {
    <h2
      [ngClass]="{
        'bg-gray-100 text-gray-500': isActive(groupedNwNumber.project!.id!),
      }"
    >
      <button
        (click)="toggleActive(groupedNwNumber.project!.id!, (groupedNwNumber.nwNumbers?.length ?? 0) > 0)"
        type="button"
        class="flex items-center justify-between w-full p-5 font-medium rtl:text-right border-t border-b-0 border-gray-200 hover:bg-gray-100 hover:text-gray-500 gap-3 h-12"
        appAgentAction
        [agent]="'nw-number-accordion-toggle-' + groupedNwNumber.project!.id"
        businessObject="project"
        [businessId]="groupedNwNumber.project!.id"
        action="toggle"
      >
        <button
          class="bg-white text-amazone-orange min-w-44 border border-amazone-orange rounded-md hover:scale-105 hover:bg-amazone-orange hover:text-white shadow cursor-pointer text-sm pl-1 pr-1"
          (click)="openProjectSidebar(groupedNwNumber.project!.id!); $event.stopPropagation()"
          type="button"
          appAgentAction
          [agent]="'nw-number-accordion-open-project-' + groupedNwNumber.project!.id"
          businessObject="project"
          [businessId]="groupedNwNumber.project!.id"
          action="open"
        >
          <span>{{ groupedNwNumber.project!.name }}</span>
        </button>
        <div class="my-2 me-2 flex justify-end gap-x-2">
          <button
            *appIfPolicySatisfied="policy.canCreateNwNumber"
            (click)="$event.stopPropagation(); toggleEnterNwNumber(groupedNwNumber.project!)"
            type="button"
            class="font-medium text-blue-400 disabled:text-gray-400 hover:text-blue-600 cursor-pointer hover:scale-110"
            appAgentAction
            [agent]="'nw-number-accordion-add-nw-number-' + groupedNwNumber.project!.id"
            businessObject="project"
            [businessId]="groupedNwNumber.project!.id"
            action="add"
          >
            <app-add></app-add>
          </button>
          <div class="flex items-center mt-1">
            <app-import-project-popover
              [project]="groupedNwNumber.project"
              (importClicked)="setProjectUpload($event.project, $event.importType)"
            ></app-import-project-popover>
          </div>
          @if (groupedNwNumber.project?.internalNotes) {
            <app-note-icon class="text-orange-300 self-center"></app-note-icon>
          }
          @if (groupedNwNumber.nwNumbers && groupedNwNumber.nwNumbers.length > 0) {
            <app-chevron-icon
              [direction]="!isActive(groupedNwNumber.project!.id!) ? arrows.DOWN : arrows.UP"
              [size]="6"
            ></app-chevron-icon>
          }
        </div>
      </button>
    </h2>
    @if (projectForUpload?.id === groupedNwNumber.project?.id) {
      <div class="my-2 me-2 flex justify-end gap-x-2">
        <app-upload-file
          [labelIsHidden]="true"
          [multiple]="allowMultiFileImport"
          [accept]="acceptedFileType"
          (fileSelected)="onFilesSelected($event)"
          (closeComponent)="projectForUpload = undefined"
        ></app-upload-file>
        <button
          [disabled]="!importFiles || importFiles.length === 0"
          (click)="uploadProjectFile()"
          class="font-medium bg-amazone-orange rounded-md text-white disabled:text-gray-400 cursor-pointer hover:scale-110 px-2 disabled:cursor-not-allowed disabled:bg-gray-200"
          appAgentAction
          [agent]="'nw-number-accordion-upload-project-file-' + groupedNwNumber.project!.id"
          businessObject="project"
          [businessId]="groupedNwNumber.project!.id"
          action="import"
        >
          <app-check></app-check>
        </button>
      </div>
    }

    @if (projectIdForCreateNwNumber?.id === groupedNwNumber.project!.id) {
      <div class="my-2 me-2 flex justify-end gap-x-2">
        <app-nw-number-number (numberEntered)="nwNumberNumberEntered($event)"></app-nw-number-number>
        <button
          (click)="triggerCreateNwNumber()"
          class="font-medium bg-amazone-orange rounded-md text-white disabled:text-gray-400 cursor-pointer hover:scale-110 px-2 disabled:cursor-not-allowed disabled:bg-gray-200"
          appAgentAction
          [agent]="'nw-number-accordion-create-nw-number-' + groupedNwNumber.project!.id"
          businessObject="project"
          [businessId]="groupedNwNumber.project!.id"
          action="confirm"
        >
          <app-check></app-check>
        </button>
      </div>
    }

    @if (isActive(groupedNwNumber.project!.id!)) {
      <div>
        <div class="ps-5 border-t border-b-0 border-gray-200">
          <div>
            @for (nwNumber of groupedNwNumber.nwNumbers; track $index) {
              <div class="ps-5">
                <div
                  class="grid grid-cols-5 border-t border-b-0 border-gray-200 text-gray-500 hover:bg-gray-100 h-22 @lg:h-12 hover:text-amazone-orange"
                  [ngClass]="{
                    'bg-orange-100': isSelected(nwNumber.id ?? ''),
                  }"
                >
                  <div
                    class="flex gap-x-6 col-span-4 cursor-pointer hover:border hover:border-amazone-orange hover:rounded-md"
                    (click)="onNwNumberClicked(nwNumber.id!)"
                    appAgentAction
                    [agent]="'nw-number-accordion-open-nw-number-' + nwNumber.id"
                    businessObject="nwNumber"
                    [businessId]="nwNumber.id"
                    action="open"
                  >
                    <div class="flex items-center">
                      <p class="ps-5 text-xs @sm:text-base">
                        {{ nwNumber.number }}
                      </p>
                    </div>
                    <div class="flex-col items-start text-xs self-center hidden @sm:block">
                      <strong>Updated by</strong>
                      <p>{{ nwNumber.modifiedBy ?? 'N/A' }}</p>
                    </div>
                    <div
                      class="flex-col items-start self-center text-xs hidden @md:block @md:col-start-4 @xl:ms-4 @2xl:col-start-3"
                    >
                      <strong>Updated at</strong>
                      <p>{{ nwNumber.modifiedOn | date: 'yyyy.MM.dd HH:mm' }}</p>
                    </div>
                  </div>
                  <div class="@md:col-start-6 col-start-5 flex justify-end gap-4 pe-10">
                    <div class="flex items-center mt-1">
                      <app-export-nw-number-popover
                        [nwNumber]="nwNumber"
                        (exportClicked)="emitNwNumberExport($event.nwNumber, $event.exportType)"
                        (publishEventsClicked)="emitPublishEvents($event.nwNumber)"
                      ></app-export-nw-number-popover>
                    </div>
                    <div class="flex items-center mt-1">
                      <app-import-nw-number-popover
                        [nwNumber]="nwNumber"
                        (importClicked)="setNwNumberUpload($event.nwNumber, $event.importType)"
                      ></app-import-nw-number-popover>
                    </div>
                    @if (nwNumber.internalNotes) {
                      <app-note-icon class="text-orange-300 self-center"></app-note-icon>
                    }
                  </div>
                </div>
              </div>
              @if (nwNumberForUpload?.id === nwNumber.id) {
                <div class="my-2 me-2 flex justify-end gap-x-2">
                  <app-upload-file
                    [labelIsHidden]="true"
                    [multiple]="allowMultiFileImport"
                    [accept]="acceptedFileType"
                    (fileSelected)="onFilesSelected($event)"
                    (closeComponent)="nwNumberForUpload = undefined"
                  ></app-upload-file>
                  <button
                    [disabled]="!importFiles || importFiles.length === 0"
                    (click)="uploadNwNumberFile()"
                    class="font-medium bg-amazone-orange rounded-md text-white disabled:text-gray-400 cursor-pointer hover:scale-110 px-2 disabled:cursor-not-allowed disabled:bg-gray-200"
                    appAgentAction
                    [agent]="'nw-number-accordion-upload-nw-number-file-' + nwNumber.id"
                    businessObject="nwNumber"
                    [businessId]="nwNumber.id"
                    action="import"
                  >
                    <app-check></app-check>
                  </button>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
  } @empty {
    <div class="p-5 text-gray-500 text-center">
      <p>No NW Numbers available.</p>
    </div>
  }
</div>
